// extracted by mini-css-extract-plugin
export default {"inputContainerUnique":"ArquivamentoSolic_inputContainerUnique__on1gC","descricao":"ArquivamentoSolic_descricao__FIptA","divPrincipal":"ArquivamentoSolic_divPrincipal__YEZw1"};